import React, { Component } from 'react';
import { Spin } from 'antd';

class TrackingModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            trackingNumber: ''
        }
    }

    onSubmit(onAdd) {

        this.setState({
            loading: true
        });

        onAdd(this, this.state.trackingNumber);
    }

    onShipOrderFinish(success) {
        this.setState({
            loading: false
        });
    }

    render() {
        const { orderId, onCancel, onAdd } = this.props;

        return (
            <div className="modal-body">
                <Spin spinning={this.state.loading} size="large">
                    <h3>{`Order #${orderId}`}</h3>
                    <div className="form-group input-txt">
                        <label htmlFor="tracking-id">Tracking Number</label>
                        <input 
                            type="text" 
                            className="form-control" 
                            name="tracking-id" 
                            placeholder="EA123456789TH" 
                            onChange={(e) => this.setState({ trackingNumber: e.target.value })}
                        />
                    </div>
                    <div className="modal-botton">
                        <button
                            className="btn button gray-btn"
                            type="cancel"
                            onClick={onCancel}
                        >
                            Cancel
                    </button>
                        <button
                            className="btn button green-btn"
                            type="submit"
                            onClick={() => this.onSubmit(onAdd)}
                        >
                            Save
                    </button>
                    </div>
                </Spin>
            </div>
        );
    }
}

export default TrackingModal;



// WEBPACK FOOTER //
// ./src/views/orders/TrackingModal.js